export default __webpack_public_path__ + "static/media/japantrad5.f2676912.png";